function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { COMPANY_ART_FOLDER_ALL_LOGOS_POPUP } from 'swag-client-common/constants';
import { isCompanyArtFolderPopupShownSelector } from 'swag-client-common/redux/popup-manager/popup-manager.selector';
import { resetLogosPaginationAction } from 'swag-client-common/redux/company-art-folder/company-art-folder.actions';
import { hidePopup, showPopup } from 'swag-client-common/redux/popup-manager/popup-manager.actions';
import { CONFIRM_DELETE_ART_FOLDER_LOGO_POPUP, COMPANY_ART_FOLDER_POPUP } from 'swag-client-common/constants';
import hasPostscriptExtension from '../../../utils/has-postscript-extension';
import { uploadLogo } from '../../../redux/product/product.actions';
import { logosListSelector, showMoreBtnSelector, selectedLogoViewSelector, isLogosListLoadingSelector } from '../../../redux/company-art-folder/company-art-folder.selectors';
import { setLogoView, selectArtFolderLogo, getCompanyArtFolderList } from '../../../redux/company-art-folder/company-art-folder.actions';
import { CompanyArtFolderPopupComponent } from './company-art-folder-popup';
const DEFAULT_ART_FOLDER_PER_PAGE = 5;
const mapStateToProps = createStructuredSelector({
  open: isCompanyArtFolderPopupShownSelector,
  logosList: logosListSelector,
  showMoreBtn: showMoreBtnSelector,
  view: selectedLogoViewSelector,
  isLoading: isLogosListLoadingSelector
});
const mapDispatchToProps = dispatch => ({
  onClose: (event, reason) => {
    if (reason) {
      return;
    }
    dispatch(hidePopup());
  },
  onSelectLogo: logoData => {
    dispatch(selectArtFolderLogo(logoData));
  },
  onRemoveLogo: (logo, isLastLogo) => {
    dispatch(showPopup(_objectSpread({
      popup: CONFIRM_DELETE_ART_FOLDER_LOGO_POPUP,
      logo
    }, !isLastLogo && {
      popupToShowAfter: COMPANY_ART_FOLDER_POPUP
    })));
  },
  onUploadLogo: (file, view) => {
    dispatch(uploadLogo(file, view));
    dispatch(setLogoView(''));
    if (hasPostscriptExtension(file)) {
      dispatch(hidePopup());
    }
  },
  onOpenMore: () => {
    dispatch(hidePopup({
      shouldControlScroll: false
    }));
    setTimeout(() => {
      dispatch(showPopup({
        popup: COMPANY_ART_FOLDER_ALL_LOGOS_POPUP
      }));
    }, 250);
  },
  updateLogoPagination: () => {
    dispatch(resetLogosPaginationAction(DEFAULT_ART_FOLDER_PER_PAGE));
  },
  loadMoreLogos: () => {
    dispatch(getCompanyArtFolderList());
  }
});
export const CompanyArtFolderPopup = connect(mapStateToProps, mapDispatchToProps)(CompanyArtFolderPopupComponent);